/* ==========================================================================
   Bedrock — BDR Video Hero (bdr-video-hero)
   ========================================================================== */

(function () {
  'use strict';

  if (customElements.get('bdr-video-hero')) return;

  class BdrVideoHero extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.toggleBtn = this.querySelector('[data-bdr-video-toggle]');
      this.pauseLabel = this.dataset.pauseLabel || '';
      this.playLabel = this.dataset.playLabel || '';

      // Avant les retours anticipes ci-dessous : sans video, ou en mouvement
      // reduit, la section doit quand meme s'ouvrir plutot que rester repliee.
      this.setupReveal();

      if (!this.video) return;

      // Le poster reste au-dessus tant que la video n'est pas jouable. S'il n'y
      // a pas de video, si elle echoue, ou en mouvement reduit (ou le src n'est
      // jamais pose), l'evenement ne vient pas et le poster reste affiche.
      this.video.addEventListener('canplay', () => {
        this.classList.add('is-video-ready');
      }, { once: true });

      if (window.Bedrock && window.Bedrock.reduceMotion()) {
        this.video.pause();
        return;
      }

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (this.video.dataset.src && !this.video.src) {
              this.video.src = this.video.dataset.src;
            }
            this.video.play().catch(() => {});
          } else {
            this.video.pause();
          }
        });
      }, { threshold: 0.1 });

      this.observer.observe(this);

      if (this.toggleBtn) {
        this.onToggle = this.handleToggle.bind(this);
        this.toggleBtn.addEventListener('click', this.onToggle);
      }
    }

    setupReveal() {
      if (!this.classList.contains('bdr-video-hero--reveal')) return;

      const reveal = () => {
        clearTimeout(this.revealTimer);
        this.classList.add('is-revealed');
      };

      const reduced = Boolean(window.Bedrock && window.Bedrock.reduceMotion());

      if (!this.video || reduced) {
        reveal();
        return;
      }

      this.video.addEventListener('canplay', reveal, { once: true });
      this.video.addEventListener('error', reveal, { once: true });

      // Filet de securite : la video n'est chargee que lorsque la section entre
      // dans le viewport, et elle peut ne jamais arriver (reseau, format refuse).
      // Sans ce delai, le hero resterait tronque indefiniment.
      this.revealTimer = setTimeout(reveal, 4000);
    }

    handleToggle() {
      if (this.video.paused) {
        this.video.play().catch(() => {});
        this.toggleBtn.setAttribute('aria-label', this.pauseLabel);
      } else {
        this.video.pause();
        this.toggleBtn.setAttribute('aria-label', this.playLabel);
      }
    }

    disconnectedCallback() {
      clearTimeout(this.revealTimer);
      if (this.observer) this.observer.disconnect();
      if (this.toggleBtn && this.onToggle) this.toggleBtn.removeEventListener('click', this.onToggle);
    }
  }

  customElements.define('bdr-video-hero', BdrVideoHero);
})();
